import validateCustomPages from './validate-custom-pages';

const validateConfig = formConfig => {
  validateCustomPages(formConfig);
};

export default validateConfig;
